import React from "react";
import {Localizer} from "../../../infrastructure/localization/localizer";
import * as Sentry from "@sentry/react";

export class ErrorBoundaryPdf extends React.Component<any, { hasError: boolean, eventId?: string, errorMessage?: string }> {
    constructor(props : any) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error : Error) {
        return { hasError: true, errorMessage: error?.message };
    }

    componentDidCatch(error: Error) {
        console.error(error);
        const eventId = Sentry.captureException(error);
        this.setState({ hasError: true, eventId, errorMessage: error?.message });
    }

    componentDidUpdate() {
        // When the fallback is rendered we must signal the IronPDF backend that we are
        // done - otherwise the renderer blocks for the full MaxWaitTime (3 min) waiting
        // for window.ironpdf.notifyRender() that would never come.
        if (this.state.hasError) {
            try {
                (window as any).ironpdf?.notifyRender?.();
            } catch {
                // best-effort
            }
        }
    }

    render() {
        if (this.state.hasError) {
            const heading = Localizer.errorGettingPdf?.() || "Fejl ved generering af PDF-fil";
            const retry = Localizer.forsoegIgenEllerKontaktSupport?.() || "Forsøg igen eller kontakt support.";
            const url = Localizer.global_uddannelseslaegedkurl?.() || "uddannelseslaege.dk";

            return (
                <div style={{ padding: "40px", fontFamily: "sans-serif", color: "#222" }}>
                    <div style={{
                        border: "2px solid #b00020",
                        borderRadius: "4px",
                        padding: "32px",
                        textAlign: "center",
                    }}>
                        <h1 style={{ color: "#b00020", marginTop: 0 }}>{heading}</h1>
                        <p>{retry}</p>
                        <p>{url}</p>
                        {this.state.eventId &&
                            <p style={{ marginTop: "24px", fontSize: "12px", color: "#666" }}>
                                <b>Fejlkode:</b> {this.state.eventId}
                            </p>
                        }
                        {this.state.errorMessage &&
                            <p style={{ marginTop: "8px", fontSize: "11px", color: "#888", fontFamily: "monospace" }}>
                                {this.state.errorMessage}
                            </p>
                        }
                    </div>

                    {/*
                        Backup signal: the componentDidUpdate above calls window.ironpdf.notifyRender()
                        (matched by WaitFor.JavaScript() in IronPdfGenerator.cs) to unblock the renderer.
                        This hidden element is kept for consistency with PdfReadySignal.
                    */}
                    <div id="pdf-ready" style={{ display: "none" }} />
                </div>
            );
        }

        return this.props.children;
    }
}
